<template>
    <vx-modal-dropdown class="resource-filter-builder" @close:popper="emit('filters:cancel')">
        <template #trigger>
            <vx-icon
                class="resource-filter-builder__icon"
                :class="{ 'resource-filter-builder__icon--active': isActive }"
                name="filter-filled"
                :size="16"
            ></vx-icon>
        </template>
        <template #content="{ close }">
            <div class="resource-filter-builder__content">
                <label class="resource-filter-builder__contnet-label">{{ title }}</label>

                <div class="resource-filter-builder__content-slot">
                    <slot></slot>
                </div>

                <div class="resource-filter-builder__buttons">
                    <vx-button
                        class="resource-filter-builder__button--reset"
                        data-test="reset-button"
                        appearance="transparent-dark"
                        size="medium"
                        @click="emit('filters:reset')"
                    >
                        Reset
                    </vx-button>
                    <div class="resource-filter-builder__buttons--left">
                        <vx-button
                            appearance="primary-dark-outline"
                            data-test="cancel-button"
                            size="medium"
                            :has-shadow="true"
                            @click="
                                () => {
                                    emit('filters:cancel');
                                    close();
                                }
                            "
                        >
                            Cancel
                        </vx-button>
                        <vx-button
                            appearance="primary-dark"
                            data-test="apply-button"
                            size="medium"
                            :has-shadow="true"
                            @click="
                                () => {
                                    emit('filters:apply');
                                    close();
                                }
                            "
                        >
                            Apply
                        </vx-button>
                    </div>
                </div>
            </div>
        </template>
    </vx-modal-dropdown>
</template>

<script setup>
import { VxModalDropdown, VxIcon, VxButton } from '@voxie/frontend-components-v3';

defineProps({
    title: { type: String, default: 'Filter Builder' },
    isActive: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['filters:reset', 'filters:cancel', 'filters:apply']);
</script>

<style lang="scss">
.resource-filter-builder {
    line-height: 1;

    .popper {
        overflow: initial;
    }
}

.resource-filter-builder__icon {
    cursor: pointer;
    color: var(--fc-color-gray-40);

    &:hover {
        path {
            fill: #139ede;
        }
    }

    &--active {
        path {
            fill: #139ede;
        }
    }
}

.resource-filter-builder__content {
    display: flex;
    flex-direction: column;
    font-family: var(--font-dm-sans);
    width: 300px;
}

.resource-filter-builder__contnet-label {
    font-size: 0.875rem;
    letter-spacing: 1px;
    font-weight: var(--weight-medium);
    color: var(--color-grey-400);
    white-space: nowrap;
    text-transform: uppercase;
    margin-bottom: 0;
}

.resource-filter-builder__content-slot {
    padding: 16px 0;
}

.resource-filter-builder__buttons {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid var(--color-grey-200);
    padding-top: 16px;
}

.resource-filter-builder__button--reset {
    border: none;
}

.resource-filter-builder__buttons--left {
    display: flex;
    gap: 8px;
}
</style>
